import {
  useLayoutEffect,
  useState,
  useEffect,
  useCallback,
  useRef,
} from "react";
import DataGrid, {
  Column,
  Export,
  HeaderFilter,
  Pager,
  Paging,
  SearchPanel,
} from "devextreme-react/data-grid";
import { reportService } from "../../../apis/apiServices/Report";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRefresh } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import { Template } from "devextreme-react";
import { useNavigate } from "react-router-dom";
import { AssetSubStatus, IconWithTooltip } from "../../../helper/fixcode";
import { Loader } from "../../Shared/PageLoader";
import { useSelector } from "react-redux";

export default function ReportAssetRequestComponent(props) {
  const user = useSelector((state) => state.user.data);

  const navigate = useNavigate();
  const [assetRequestList, setAssetRequestList] = useState([]);
  const refDataGrid = useRef(null);
  const [state, setState] = useState({
    isCompleteLoading: false,
    loadingMessage: "Loading Report...",
  });

  useLayoutEffect(() => {
    document.querySelector("#pageTitle").innerHTML = `Asset Request`;
  }, []);

  let isUseEffectRendered = false;
  useEffect(() => {
    const controller = new AbortController();
    try {
      if (isUseEffectRendered) {
        return;
      }
      fetchApiOnPageLoad();
      return () => {
        controller.abort();
        isUseEffectRendered = true;
      };
    } catch (error) {
      console.log(error);
    }
  }, []);

  const fetchApiOnPageLoad = useCallback(async () => {
    try {
      setState((prevState) => ({
        ...prevState,
        isCompleteLoading: true,
      }));
      await getAssetRequestList(0);
    } catch (error) {
      console.log(error);
    } finally {
      setState((prevState) => ({
        ...prevState,
        isCompleteLoading: false,
      }));
    }
  }, []);

  const getAssetRequestList = async () => {
    try {
      //refDataGrid?.current?.instance?.beginCustomLoading();
      let body = {
        requestId: 0,
        statusId: AssetSubStatus.AssetRequestApproved,
        userId: user?.userId,
      };
      const response = await reportService.getAssetRequestList(body);
      setAssetRequestList(response?.data ?? []);
    } catch (error) {
      console.log(error);
    } finally {
      //refDataGrid?.current?.instance?.endCustomLoading();
    }
  };

  return (
    <>
      <div className="content">
        <div className="card">
          <div className="card-body">
            <div className="row">
              <div className="col-12">
                <DataGrid
                  ref={refDataGrid}
                  dataSource={assetRequestList}
                  showColumnLines={false}
                  showRowLines={true}
                  showBorders={true}
                  allowColumnResizing={false}
                  allowColumnReordering={true}
                  columnAutoWidth={true}
                  onToolbarPreparing={(e) => {
                    e.toolbarOptions.items.unshift({
                      location: "before",
                      template: "toolbarRefreshTemplate",
                    });
                  }}
                >
                  <Column
                    dataField="id"
                    width={25}
                    caption=""
                    allowExporting={false}
                    allowFiltering={false}
                    allowSearch={false}
                    allowSorting={false}
                    cellRender={(cellData) => {
                      const idPrefix = `icon-${cellData?.data?.id}`;
                      return (
                        <>
                          <div style={{ display: "flex" }}>
                            {props?.featurePermission?.canView && (
                              <>
                                <span>
                                  <IconWithTooltip
                                    id={`${idPrefix}-view`}
                                    className="iconify-size mr-1"
                                    title="View asset request"
                                    tooltip="View asset request"
                                    icon="solar:document-text-outline"
                                    style={{ cursor: "pointer" }}
                                    onClick={() =>
                                      navigate("/asset-preview", {
                                        state: {
                                          requestId: cellData?.data?.requestId,
                                          sourceUrl: "ReportAssetRequest",
                                          isReport: true,
                                        },
                                      })
                                    }
                                  />
                                </span>
                              </>
                            )}
                          </div>
                        </>
                      );
                    }}
                  />
                  <Column
                    dataField="requestNo"
                    caption="Request No"
                    allowSearch={true}
                    allowFiltering={false}
                    allowSorting={true}
                  />
                  <Column
                    dataField="assetStatus"
                    caption="Status"
                    allowSearch={true}
                    allowFiltering={false}
                    allowSorting={true}
                    cellRender={(e) => {
                      let color = "#28A745";
                      if (
                        e.data?.statusId === AssetSubStatus.AssetRequestPending
                      )
                        color = "#494545ff";
                      else if (
                        e.data?.statusId === AssetSubStatus.AssetRequestApproved
                      )
                        color = "#4CAF50";
                      else if (
                        e.data?.statusId ===
                        AssetSubStatus.AssetRequestSendforApproval
                      )
                        color = "#FF9800";
                      else if (
                        e.data?.statusId === AssetSubStatus.AssetRequestRecall
                      )
                        color = "#ee0a0aff";
                      else if (
                        e.data?.statusId ===
                        AssetSubStatus.AssetRequestBackToDraft
                      )
                        color = "#ee0a0aff";

                      return (
                        <div>
                          <span style={{ color }}>{e.data?.assetStatus}</span>
                          {/* <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                        {e.data?.currentUserId > 0
                          ? e.data?.currentUserName
                          : e.data?.fromName}
                      </div> */}
                        </div>
                      );
                    }}
                  />
                  <Column
                    dataField="requestedDate"
                    caption="Request Date"
                    allowSearch={true}
                    allowFiltering={false}
                    allowSorting={true}
                    dataType="date"
                    format="dd-MMM-yyyy"
                  />
                  <Column
                    dataField="fromName"
                    caption="From"
                    allowSearch={true}
                    allowFiltering={false}
                    allowSorting={true}
                    //alignment={"center"}
                    cellRender={(data) => {
                      if (data?.data?.fromName) {
                        return (
                          <>
                            <span>{data?.data?.fromName ?? ""}</span>
                            <br />
                            <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                              {data?.data?.fromDepartment ?? ""}
                            </div>
                          </>
                        );
                      } else {
                        return "";
                      }
                    }}
                  />
                  <Column
                    dataField="toName"
                    caption="To"
                    allowSearch={true}
                    allowFiltering={false}
                    allowSorting={true}
                    //alignment={"center"}
                    cellRender={(data) => {
                      if (data?.data?.toName) {
                        return (
                          <>
                            <span>{data?.data?.toName ?? ""}</span>
                            <br />
                            <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                              {data?.data?.toDepartment ?? ""}
                            </div>
                          </>
                        );
                      } else {
                        return "";
                      }
                    }}
                  />
                  {/* <Column
                dataField="fromName"
                caption="From"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
              /> */}
                  <Column
                    dataField="projectName"
                    caption="Project"
                    allowSearch={true}
                    allowFiltering={false}
                    cellRender={(data) => {
                      return (
                        <>
                          <span>{data?.data?.projectName ?? ""}</span>
                          {data?.data?.locationName && (
                            <>
                              <br />
                              <div
                                style={{ color: "#b1b1b1", fontSize: "11px" }}
                              >
                                {data?.data?.locationName ?? ""}
                              </div>
                            </>
                          )}
                        </>
                      );
                    }}
                  />
                  <Column
                    dataField="assetDescriptions"
                    caption="Asset Description"
                    allowSearch={true}
                    allowFiltering={false}
                    allowSorting={true}
                  />
                  <Template
                    name="toolbarRefreshTemplate"
                    render={() => {
                      return (
                        <>
                          <button
                            className="btn btn-outline-primary btn-sm"
                            onClick={async () => {
                              await getAssetRequestList(0);
                            }}
                            title="Refresh"
                          >
                            <FontAwesomeIcon icon={faRefresh} />
                            &nbsp;Refresh
                          </button>
                        </>
                      );
                    }}
                  />
                  <HeaderFilter visible={false} />
                  <SearchPanel
                    visible={true}
                    highlightCaseSensitive={true}
                    width={240}
                    placeholder="Search..."
                  />
                  <Paging defaultPageSize={15} />
                  <Pager displayMode="compact" showInfo={true} visible={true} />
                  <Export enabled={true} fileName="Asset Request Report" />
                </DataGrid>
              </div>
            </div>
          </div>
        </div>
      </div>

      {state.isCompleteLoading && (
        <Loader loadingMessage={state.loadingMessage} />
      )}
    </>
  );
}
